<template>
  <div id="logStatus">
    <!-- <span v-if="userLoggedInStatus" style="font-style: italic"
      >Howdy {{ EMAIL }} {{ UID }}</span
    > -->
    <router-link v-if="!userLoggedInStatus" to="/login">Login</router-link>
    <button v-if="!userLoggedInStatus" type="button" class="btn btn-warning">
      <router-link to="/register">Register</router-link>
    </button>
    <button
      id="signOutButton"
      v-if="userLoggedInStatus"
      type="button"
      class="btn btn-secondary"
      @click="signOut"
    >
      Sign Out
    </button>
  </div>
</template>

<script>
import { mapState } from "vuex";
import firebase from "firebase/app";
import "firebase/auth";

export default {
  data() {
    return {
      loggedIn: false,
      UID: null,
      EMAIL: null
    };
  },
  created() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.$store.commit("loggedInStatus", true);
        // console.log("this is the user");
        console.log(user);
        // console.log("this is the user UID");
        // console.log(user.uid);
        this.UID = user.uid;
        this.EMAIL = user.email;
      } else {
        this.$store.commit("loggedInStatus", false);
      }
    });
  },
  computed: {
    ...mapState(["userLoggedInStatus"])
  },
  methods: {
    async signOut() {
      try {
        const data = await firebase.auth().signOut();
        console.log(data);
        this.$router.replace({ name: "login" });
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.btn {
  color: white;
  border-radius: 0px;
}

.btn.btn-warning {
  * {
    color: white !important;
  }
}

#logStatus {
  position: absolute;
  top: 0px;
  right: 10px;
  height: 44px;
  color: white;
  font-size: 16px;
  display: flex;

  > #signOutButton {
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
  }

  > * {
    align-self: center;
    margin: 0px 5px;
  }
}
</style>
